import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import AddBoxIcon from "@mui/icons-material/AddBox";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import {
  Avatar,
  Box,
  Button,
  Checkbox,
  Chip,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  OutlinedInput,
  TablePagination,
} from "@mui/material";
import "./SupplierListView.scss";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { Fragment, useEffect, useState } from "react";
import { t } from "i18next";
import { primaryColor } from "../../../constants/colorConstants";
import { useNavigate } from "react-router-dom";
import { axiosAuth } from "../../../services/interceptor";
import {
  getSupplierCount,
  getSupplierList,
  updateMultipleSuppliers,
} from "../../../services/srmService";
import SupplierDetailedView from "../SupplierDetailedView/SupplierDetailedView";
import SkeletonLoader from "../../common/Skeletons/TableSkeleton/TableSkeletonLoader";
import { useSelector } from "react-redux";
import {
  checkSubscriptionLimit,
  checkSubscriptionPermission,
} from "../../../helper";
import UpgradeMessageDialog from "../../Subscription/UpgradeMessageDialog";

function SupplierListView() {
  let [enableListView, setEnableListView] = useState(true);
  let [totalCount, setTotalCount] = useState(0);
  let [search, setSearch] = useState("");
  let [loading, setLoading] = useState(true);
  let [isCheckBoxSelected, setIsCheckBoxSelected] = useState(false);
  const [controller, setController] = useState({
    page: 0,
    limit: 10,
  });
  let cellColumns = [
    " ",
    "Company Name",
    "Primary Contact",
    "Address",
    "Status",
    "Registration",
  ];

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleNewDropDownClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const [openDialog, setOpenDialog] = useState(false);

  const handleCreation = (isManual?: boolean) => {
    setAnchorEl(null);

    if (isManual != undefined) {
      handleNewClick(isManual);
    }
  };

  const handleSearch = (e: any) => {
    setSearch(e.target.value);
  };
  const navigate = useNavigate();

  const fetchSuppliers = () => {
    setLoading(true);
    getSupplierList(controller.page, controller.limit, search).then((res) => {
      setRows(
        res.data.map((item: any) => {
          return {
            name: item.name,
            contact: item.contactName,
            address: item.address?.city,
            status: item.disabled ? "Inactive" : "Active",
            registration: item.activationDate ? "Registered" : "Unregistered",
            id: item.id,
            logo: item.logo,
            selected: false,
          };
        })
      );
      getSupplierCount()
        .then((res) => {
          setTotalCount(res.data.count);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };
  let [supplierSortIndex, setSupplierSortIndex] = useState(0);
  useEffect(() => {
    fetchSuppliers();
  }, [controller.page, controller.limit, search]);

  const [rows, setRows] = useState(
    [] as {
      name: string;
      contact: string;
      address: string;
      status: string;
      registration: string;
      id: number;
      selected: boolean;
      logo: string;
    }[]
  );
  useEffect(() => {
    if (rows.length > 0) {
      if (activeIndex === 0) {
        setActiveId(rows[rows.length - 1].id);
        setActiveIndex(rows.length - 1);
      } else {
        setActiveId(rows[0].id);
        setActiveIndex(0);
      }
    }
  }, [rows]);

  const handlePageChange = (event: any, newPage: number) => {
    setController({
      ...controller,
      page: newPage,
    });
  };

  const handleChangeRowsPerPage = (event: any) => {
    setController({
      ...controller,
      limit: parseInt(event.target.value, 10),
      page: 0,
    });
  };

  const changeSupplierStatus = (evt: any, type: string) => {
    const data = {
      ids: selectedRowIds,
      active: type == "active",
    };
    updateMultipleSuppliers(data).then((res) => {
      if (res.status === 200) {
        resetSelection();
        fetchSuppliers();
      }
    });
  };

  const resetSelection = () => {
    setIsCheckBoxSelected(false);
    setSelectedRowIds([]);
    let tempRows = rows.map((row) => {
      row.selected = false;
      return row;
    });
    setRows([...tempRows]);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const permissions = useSelector((state: any) => state.auth.userPermissions);
  const plansPermissions = useSelector(
    (state: any) => state.sub.subscriptionPermissions
  );
  const addonPermissions = useSelector(
    (state: any) => state.sub.addonPermissions
  );
  const companyPreferences = useSelector(
    (state: any) => state.org.companyPreferences
  );

  const handleNewClick = (isManual: boolean) => {
    if (
      checkSubscriptionPermission(
        "SUPPLIER",
        plansPermissions,
        totalCount,
        addonPermissions
      )
    ) {
      if (isManual) {
        console.log("opening creation screen");
        navigate("/partners/suppliers/create");
      } else {
        navigate("/partners/suppliers/bulk-upload");
      }
    } else {
      setOpenDialog(true);
    }
  };
  const [selectedRowIds, setSelectedRowIds] = useState<any[]>([]);
  const handleSingleCheckbox = (event: any, row: any, index: any) => {
    if (event.target.checked) {
      selectedRowIds.push(row.id);
    } else {
      let ind = selectedRowIds.findIndex((id) => id == row.id);
      selectedRowIds.splice(ind, 1);
    }
    const enableToggle = selectedRowIds.length > 0;
    rows[index].selected = event.target.checked;
    setIsCheckBoxSelected(enableToggle);
    setSelectedRowIds([...selectedRowIds]);
    setRows([...rows]);
  };
  const [activeId, setActiveId] = useState<any>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const openDetailedView = (id: any, index: any) => {
    setSupplierSortIndex(controller.page * controller.limit + index);
    setEnableListView(false);
    setActiveIndex(index);
    setActiveId(id);
  };

  const onClose = () => {
    setEnableListView(true);
  };
  const prev = () => {
    const isFirstRowOnPage = activeIndex === 0;
    if (isFirstRowOnPage) {
      if (controller.page > 0) {
        setController({
          ...controller,
          page: controller.page - 1,
        });
      }
    } else {
      setActiveId(rows[activeIndex - 1].id);
      setActiveIndex(activeIndex - 1);
    }
  };
  const next = () => {
    const isLastRowOnPage = activeIndex === rows.length - 1;
    if (isLastRowOnPage) {
      if ((controller.page + 1) * controller.limit < totalCount) {
        setController({
          ...controller,
          page: controller.page + 1,
        });
      }
    } else {
      setActiveId(rows[activeIndex + 1].id);
      setActiveIndex(activeIndex + 1);
    }
  };

  return (
    <>
      <div className="flex flex-row relative">
        <Box
          className="pw-supplier-list p-0"
          width={enableListView ? "100%" : "35%"}
          flexShrink={0}
          marginLeft={enableListView ? " " : "-50px"}
          marginTop={"-24px"}
          bgcolor={enableListView ? "" : "#EAEEF4"}
        >
          <div
            className={`flex flex-row justify-between gap-4 mb-3 w-full ${
              enableListView ? "pt-3" : "pw-padding-side-2"
            }`}
          >
            <OutlinedInput
              id="outlined-adornment-password "
              className="pw-search-field"
              placeholder={t("Search")}
              onChange={handleSearch}
              endAdornment={
                <InputAdornment position="end">
                  {search === "" ? (
                    <IconButton edge="end">
                      <SearchIcon />
                    </IconButton>
                  ) : (
                    <IconButton edge="end">
                      <CloseIcon />
                    </IconButton>
                  )}
                </InputAdornment>
              }
            />
            {isCheckBoxSelected && enableListView ? (
              <div className="pw-check-options">
                <Button onClick={resetSelection}>Cancel</Button>
                <Button
                  onClick={(e) => changeSupplierStatus(e, "inactive")}
                  sx={{ marginRight: "20px", marginLeft: "20px" }}
                >
                  Mark as Inactive
                </Button>
                <Button onClick={(e) => changeSupplierStatus(e, "active")}>
                  Mark as Active
                </Button>
              </div>
            ) : (
              <div className="flex">
                <div
                  id="pw-e2e-add-supplierbtn"
                  className="pw-add-new-supplier"
                >
                  <div
                    className="flex gap-1"
                    onClick={(e) => handleNewClick(true)}
                  >
                    <AddBoxIcon className="pw-box-icon" />
                    {t("New")}
                  </div>
                </div>
                <div
                  style={{
                    background: primaryColor,
                    padding: "5px 10px",
                    marginLeft: "0.5px",
                    borderBottomRightRadius: "5px",
                    borderTopRightRadius: "5px",
                    color: "white",
                  }}
                  className="cursor-pointer"
                >
                  <ArrowDropDownIcon
                    className="pw-box-icon"
                    onClick={(e) => handleNewDropDownClick(e)}
                    sx={{ borderRight: "black" }}
                  />
                </div>
                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={() => handleCreation()}
                >
                  <MenuItem onClick={() => handleCreation(true)}>
                    {t("Manual")}
                  </MenuItem>
                  <MenuItem onClick={() => handleCreation(false)}>
                    {t("Bulk Upload")}
                  </MenuItem>
                </Menu>
              </div>
            )}
          </div>
          {loading ? (
            <SkeletonLoader type="text" cells={cellColumns} />
          ) : (
            <Fragment>
              {enableListView ? (
                <TableContainer
                  component={Paper}
                  sx={{ height: "60vh", overflowY: "auto" }}
                >
                  <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                      <TableRow className="h-14">
                        <TableCell className="bg-neutral-50"></TableCell>
                        {cellColumns.map((eachCell: any, index) => (
                          <TableCell
                            key={index}
                            id={eachCell + "-th"}
                            className="bg-neutral-50"
                          >
                            <div className="text-neutral-600">{eachCell}</div>
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows.length ? (
                        rows.map((row, index) => (
                          <TableRow
                            key={row.name}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                              cursor: "pointer",
                            }}
                          >
                            <TableCell sx={{ width: "5vw" }}>
                              <Checkbox
                                onChange={(e) =>
                                  handleSingleCheckbox(e, row, index)
                                }
                                checked={row.selected}
                              />
                            </TableCell>
                            <TableCell
                              style={{ cursor: "pointer" }}
                              onClick={() => openDetailedView(row.id, index)}
                              sx={{ width: "5vw" }}
                            >
                              <Avatar src={row.logo} />
                            </TableCell>
                            <TableCell
                              style={{ cursor: "pointer" }}
                              onClick={() => openDetailedView(row.id, index)}
                            >
                              {row.name}
                            </TableCell>
                            <TableCell
                              style={{ cursor: "pointer" }}
                              onClick={() => openDetailedView(row.id, index)}
                            >
                              {row.contact}
                            </TableCell>
                            <TableCell
                              style={{ cursor: "pointer" }}
                              onClick={() => openDetailedView(row.id, index)}
                            >
                              {row.address}
                            </TableCell>
                            <TableCell
                              style={{ cursor: "pointer" }}
                              onClick={() => openDetailedView(row.id, index)}
                            >
                              {row.status == "Active" ? (
                                <span
                                  style={{
                                    color: "#59CE90",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Active
                                </span>
                              ) : (
                                <span style={{ color: "#8897AE" }}>
                                  Inactive
                                </span>
                              )}
                            </TableCell>
                            <TableCell
                              onClick={() => openDetailedView(row.id, index)}
                            >
                              <Chip
                                label={row.registration}
                                sx={{
                                  cursor: "pointer",
                                  backgroundColor:
                                    row.registration == "Registered"
                                      ? "#EEF6ED"
                                      : "#EAEEF4",
                                  fontWeight: "bold",
                                  color:
                                    row.registration == "Registered"
                                      ? "#70A268"
                                      : "#3D4A5C",
                                }}
                              />
                            </TableCell>
                          </TableRow>
                        ))
                      ) : loading ? (
                        <td colSpan={7} className="text-center">
                          Loading..
                        </td>
                      ) : (
                        <td colSpan={7} className="text-center">
                          No Data
                        </td>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <div
                  className="flex flex-col gap-y-0.5"
                  style={{
                    height: "60vh",
                    overflowX: "auto",
                    overflowY: "auto",
                    marginTop: "-10px",
                  }}
                >
                  {rows.length ? (
                    rows.map((row, index) => (
                      <div
                        style={{
                          cursor: "pointer",
                          backgroundColor:
                            activeId == row.id ? "#F5F7FA" : "white",
                        }}
                        onClick={() => openDetailedView(row.id, index)}
                        className="flex flex-row gap-x-3 items-center pw-bunitlist-card bg-white"
                      >
                        <Avatar src={row.logo} />
                        <div>
                          <div>{row.name}</div>
                          <div>{row.contact || ""}</div>
                        </div>
                      </div>
                    ))
                  ) : loading ? (
                    <div className="text-center">Loading..</div>
                  ) : (
                    <div className="text-center">No Data</div>
                  )}
                </div>
              )}
              {totalCount > 10 ? (
                <TablePagination
                  component="div"
                  onPageChange={handlePageChange}
                  page={controller.page}
                  count={totalCount}
                  rowsPerPage={controller.limit}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              ) : (
                ""
              )}
            </Fragment>
          )}
        </Box>
        {enableListView ? (
          ""
        ) : (
          <SupplierDetailedView
            onNext={next}
            onPrev={prev}
            sortIndex={supplierSortIndex}
            totalCount={totalCount}
            supplierId={activeId}
            onClose={onClose}
            activeIndex={activeIndex}
            limit={controller.limit}
            page={controller.page}
          />
        )}
      </div>
      {openDialog && (
        <UpgradeMessageDialog
          open={openDialog}
          onClose={handleClose}
          limit={checkSubscriptionLimit(
            "SUPPLIER",
            plansPermissions,
            addonPermissions
          )}
          limitType={totalCount === 1 ? "supplier" : "suppliers"}
        />
      )}
    </>
  );
}
export default SupplierListView;
